/* Routes to the appropriate page and makes API data available to them */
import { Routes, Route } from "react-router-dom";
import WithApi from "../hooks/WithApi";
import useLivepeer from "../hooks/WithLivepeer";
import TranscoderPage from "./TranscoderPage";
import DelegatorPage from "./DelegatorPage";
import BroadcasterPage from "./BroadcasterPage";

export default function LoadingScreen() {
  const {
    transcoderInfo,
    poolInfo,
    poolStatus,
    orchInfo,
    cachedENS,
    paymentInfo,
  } = WithApi();
  const {
    allowance,
    currentRound,
    ETHbalance,
    LPTbalance,
    bondedWith,
    delegatorState,
    bondedLPT,
    thisProgress,
    transcoderTable,
    isTranscoderTableErr,
    refreshWallet,
    getHints,
    connectWallet,
    connectedWallet,
    checkIfWalletIsConnected,
    locks,
    pendingEth,
    isSyncing,
  } = useLivepeer();

  return (
    <Routes>
      <Route
        path="/stake"
        element={
          <DelegatorPage
            orchInfo={orchInfo}
            allowance={allowance}
            currentRound={currentRound}
            ETHbalance={ETHbalance}
            LPTbalance={LPTbalance}
            bondedWith={bondedWith}
            delegatorState={delegatorState}
            bondedLPT={bondedLPT}
            thisProgress={thisProgress}
            transcoderTable={transcoderTable}
            isTranscoderTableErr={isTranscoderTableErr}
            refreshWallet={refreshWallet}
            getHints={getHints}
            connectWallet={connectWallet}
            connectedWallet={connectedWallet}
            locks={locks}
            checkIfWalletIsConnected={checkIfWalletIsConnected}
            pendingEth={pendingEth}
            isSyncing={isSyncing}
            cachedENS={cachedENS}
          />
        }
      />
      <Route
        path="/broadcast"
        element={<BroadcasterPage transcoderInfo={transcoderInfo} />}
      />
      <Route
        path="*"
        element={
          <TranscoderPage
            transcoderInfo={transcoderInfo}
            poolStatus={poolStatus}
            cachedENS={cachedENS}
            poolInfo={poolInfo}
            paymentInfo={paymentInfo}
          />
        }
      />
    </Routes>
  );
}
